import { Component, Input, OnInit } from '@angular/core';
import { map, Observable, Subject, take } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { faDoorOpen } from '@fortawesome/free-solid-svg-icons';
import { SmartlockerAccessCodeResponse } from '../../interfaces/smartlocker-access-code.interface';
import { SmartlockerService } from '../../services/smartlocker.service';

@Component({
    selector: 'pace-smartlocker-access-code',
    templateUrl: './smartlocker-access-code.component.html',
    styleUrls: ['./smartlocker-access-code.component.scss'],
    standalone: false,
})
export class SmartlockerAccessCodeComponent implements OnInit {
    @Input() public smartlockerId: number;
    @Input() public smartlockerDoorId: number;

    public modalResult = new Subject<string>();
    public smartlockerAccessCodeResponse$: Observable<SmartlockerAccessCodeResponse>;
    protected readonly faDoorOpen = faDoorOpen;

    public constructor(
        private readonly smartlockerService: SmartlockerService,
        public readonly modalInstance: BsModalRef,
    ) {}

    public ngOnInit(): void {
        this.smartlockerAccessCodeResponse$ = this.smartlockerService
            .getAccessCode(this.smartlockerId, this.smartlockerDoorId)
            .pipe(
                take(1),
                map((response: SmartlockerAccessCodeResponse) => {
                    return {
                        ...response,
                        BarcodeBase64: `data:image/png;base64,${response.BarcodeBase64}`,
                    };
                }),
            );
    }

    public onConfirmedDoorOpenedClick(accessCode: string): void {
        this.close(accessCode);
    }

    public close(accessCode = ''): void {
        this.modalResult.next(accessCode);
        this.modalResult.complete();
        this.modalInstance.hide();
    }
}
